/**
 * Created by rafal on 03.04.17.
 */
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { choseParcel, sideDescriptionView } from '../../../actions/district';
import { fetchParcelById } from '../../../actions/postGeoData';
import s from './Finder.scss';
import _ from 'lodash';

// this.state = {
//   dzialki: null,
//   availableParcels: null,
//   selectedParcels: '',
//   inputValue: '',
//   isFinderOpened: false,
//   isAdvancedFinderActivated: false,
// };

class Finder extends React.Component {
  state = {
    selectedParcels: [],
  };

  onChange = v => {
    const parcel = _.find(this.props.district.parcels, item => item.nr_dzialki === v.label);
    this.props.choseParcel(parcel);
  };

  changeInput = () => {};

  sortParcelsByLength = arr =>
    arr.sort(
      (a, b) =>
        // ASC  -> a.length - b.length
        // DESC -> b.length - a.length
        a.label.length - b.label.length,
    );

  sortParcelByObreb = arr =>
    arr.sort((a, b) => {
      const aLbl = a.label.split(/[\.\-]/);
      const bLbl = b.label.split(/[\.\-]/);
      return parseInt(aLbl[1]) > parseInt(bLbl[1]);
    });

  render() {
    if (this.props.areParcelsBeingFetched) {
      return (
        <div id="select-box" className="select-box">
          <h3>Pobieranie działek</h3>
        </div>
      );
    }

    if (
      !this.props.areParcelsBeingFetched &&
      this.props.district &&
      this.props.district.prefix != 'krosno' &&
      this.props.areParcelsFetched
    ) {
      const options = this.sortParcelsByLength(
        this.props.district.parcels.map((v, i) => ({ value: v.nr_dzialki, label: v.nr_dzialki })),
      );

      return (
        <div id="select-box" className="select-box">
          <Select
            name="find-my-parcel"
            placeholder="Wybierz działkę..."
            noResultsText="Nie ma takiej działki."
            value={
              this.props.chosenParcel
                ? {
                  value: this.props.chosenParcel.nr_dzialki,
                  label: this.props.chosenParcel.nr_dzialki,
                }
                : {}
            }
            options={options.slice(0, 10)}
            onChange={this.onChange}
            onInputChange={this.changeInput}
          />
        </div>
      );
    }
    return null;
  }
}

const mapState = state => ({
  district: state.district.district,
  areParcelsBeingFetched: state.district.areParcelsBeingFetched,
  areParcelsFetched: state.district.areParcelsFetched,
  sideDescriptionShow: state.district.sideDescriptionShow,
  chosenParcel: state.district.chosenParcel,
});

const mapDispatch = {
  fetchParcelById,
  sideDescriptionView,
  choseParcel,
};

Finder.propTypes = {
  district: PropTypes.shape({
    parcels: PropTypes.arrayOf(PropTypes.object),
  }),
  chosenParcel: PropTypes.object,
  areParcelsBeingFetched: PropTypes.bool,
  areParcelsFetched: PropTypes.bool,
  sideDescriptionShow: PropTypes.bool,
  fetchParcelById: PropTypes.func,
  sideDescriptionView: PropTypes.func,
  choseParcel: PropTypes.func,
};

export default withStyles(s)(
  connect(
    mapState,
    mapDispatch,
  )(Finder),
);



// WEBPACK FOOTER //
// src/components/SearchBox/Finder/Finder.js